
<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="subgroupForm">
    <div class="">
      <h3 class="form_name">SubGroup</h3>


        <div class="input">
          <label for="">Sub Group Name</label>
          <input type="text" class="default_input reference-form" formControlName="SubGroupName" />
        </div>
        <div class="input">
          <label for="">Sub Group Code</label>
          <input type="text" class="default_input reference-form" formControlName="SubGroupCode" />
        </div>
        <div class="input">
            <label for="">Divestment Status Name</label>
            <select name="" class="default_input reference-form" formControlName="DivestmentStatusId" >
                <option *ngFor="let divestmentstatus of divestmentstatuss" [value]="divestmentstatus.id">{{divestmentstatus.DivestmentStatusName}}</option>
            </select>
          </div>
  

      <div class="btn_holder">
        <button class="default_primary-button" *ngIf="selectedIndex === null"
          (click)="addNew(subgroupForm.value)">Add</button>
        <button class="default_primary-button" *ngIf="selectedIndex !== null"
          (click)="addNew(subgroupForm.value)">Update</button>
        <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

      </div>

    </div>
  </form>
    <div class="display_table" >
      <div class="search_container">
        <input type="text" class="default_input search"
        placeholder="Search for SubGroup"
        [formControl]="control"
        [appAutocomplete]="autocomplete"
        />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container
              *ngIf="(groups | filterReference: control.value) as result"
            >
              <app-option
                (click)="selectGroup(option.id)"
                *ngFor="let option of result"
                [value]="option.GroupName"
              >
                {{ option.GroupName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length"
                >No result...</app-option
              >
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head" >
        <span class="item">S/N</span>
        <span class="item">Sub Group Name</span>  
        <span class="item">Sub Group Code</span>
        <span class="item">Divestment Status</span>
        <span class="item">Action</span>

      </div>

    <div class="scroll">

    </div>
    <div class="body_content" *ngIf="status">
      <div class="the_body"
      *ngFor="let subgroup of subgroupFormArray.get('SubGroups')['controls']; index as i"
      (click)="onEdit(i, subgroup.value)" style="cursor: pointer;"
      matTooltip="Click to edit"
        aria-label="Button that displays a tooltip when focused or hovered over"
      >
        <span class="content">{{i + 1}}</span>
        <span class="content">{{subgroup?.value.SubGroupName}}</span>
        <span class="content">{{subgroup?.value.SubGroupCode}}</span>
        <span class="content">{{getDivestmentStatusName(subgroup?.value.DivestmentStatusId)}}</span>
        <span class="content" (click)="$event.stopImmediatePropagation()">
          <button
          class="delete_icon trash"

          (click)="deleteSubGroup(i, subgroup.value)">
          <em class="ti-trash"> </em> </button>
        </span>

      </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(subgroupFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>

  
  
   